import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  deptFrom: string;    // 部門代號篩選下限
  deptTo: string;      // 部門代號篩選上限
  empFrom: string;     // 人員代號篩選下限
  empTo: string;       // 人員代號篩選上限
  yearMonFrom: string; // 年度月份篩選下限 YYYYMM
  yearMonTo: string;   // 年度月份篩選上限 YYYYMM
}

export interface SalaryChangeRow {
  deptCode: string;
  deptName: string;
  empCode: string;
  empName: string;
  yearMonth: string;
  seqNo: number;
  itemCode: string;
  itemName: string;
  salaryBefore: number;
  salaryAfter: number;
  remark: string;
  changeNo: string;
  effDate: string | null;
}

export interface EmpSummary {
  deptCode: string;
  deptName: string;
  empCode: string;
  empName: string;
  salaryFirst: number;
  salaryLast: number;
}

export interface QueryResponse {
  details: SalaryChangeRow[];
  summaries: EmpSummary[];
  totalCount: number;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const pw9334Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9334/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/pw9334/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
